module.exports = __webpack_public_path__ + "img/sq.1239bf7f.png";